import React from 'react'

function NotFound() {
  return (
    <div>
      <h1 style={{ marginTop: "15rem" }}>404 Not Found ¡Llegaste a una página que no existe!</h1>
    </div>
  )
}

export default NotFound
